import { Injectable, inject } from "@angular/core";
import { UserCredential } from "@angular/fire/auth";
import { Auth, signInWithEmailAndPassword } from "@angular/fire/auth";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private auth = inject(Auth);

  async signIn(email: string, password: string): Promise<UserCredential> {
    const userCredential = await signInWithEmailAndPassword(
      this.auth,
      email,
      password
    );
    const user = userCredential.user;

    const tokenResult = await user.getIdTokenResult(true); // force refresh
    const isAdmin = tokenResult.claims["admin"] === true;

    if (!isAdmin) {
      await this.auth.signOut();
      throw new Error("Unauthorized");
    }

    return userCredential;
  }

  signOut(): Promise<void> {
    return this.auth.signOut();
  }
}
